<template>
  <el-table
    :data="tableData"
    class="egl-table"
    stripe
    :span-method="spanMethod"
    :cell-class-name="setCellClassName"
  >
    <el-table-column :label="$locale('accountPayable.arithmetic')">
      <template slot-scope="scope">
        <el-select v-model="scope.row.plus" @change="setMathematical(scope.$index)" v-if="scope.$index < tableData.length - 1">
          <el-option :value="true" :label="$locale('accountPayable.plus')"></el-option>
          <el-option :value="false" :label="$locale('accountPayable.reduce')"></el-option>
        </el-select>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('global.cinemaName')">
      <template slot-scope="scope">
        <el-select v-model="scope.row.cinemaId" @change="selectCinemaId(scope.$index)">
          <el-option :value="item.id" :label="item.name" v-for="item in cinemaList" :key="item.id"></el-option>
        </el-select>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('accountPayable.itemName')">
      <template slot-scope="scope">
        <el-select v-model="scope.row.otherGoodsId" @change="selectOtherGoodsId(scope.$index)" v-if="scope.$index < tableData.length - 1">
          <el-option :value="item.id" :label="item.name" v-for="item in otherGoodsOption[scope.$index]" :key="item.id"></el-option>
        </el-select>
        <span v-else>{{ scope.row.otherName }}</span>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('global.unitPrice')">
      <template slot-scope="scope">
        <el-input
          v-model="scope.row.price"
          @input="setRowTotalPrice(scope.$index, 'price', true)"
          @blur="setRowTotalPrice(scope.$index, 'price', false)"
          v-if="scope.$index < tableData.length - 1"
        ></el-input>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('global.quantity')">
      <template slot-scope="scope">
        <el-input
          v-model="scope.row.inventory"
          @input="setRowTotalPrice(scope.$index, 'inventory', true)"
          @blur="setRowTotalPrice(scope.$index, 'inventory', false)"
          v-if="scope.$index < tableData.length - 1"
        ></el-input>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('global.unit')">
      <template slot-scope="scope">
        <el-input v-model="scope.row.unit" @blur="setProp" v-if="scope.$index < tableData.length - 1"></el-input>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('accountPayable.offsetAmount')">
      <template slot-scope="scope">
        {{ scope.row.payAmount.toLocaleString() }}
      </template>
    </el-table-column>

    <el-table-column :label="$locale('global.detail') + '/' + $locale('global.description')">
      <template slot-scope="scope">
        <el-input v-model="scope.row.comment" v-if="scope.$index < tableData.length - 1" :placeholder="$locale('accountPayable.placeholder.input')" @blur="setProp"></el-input>
      </template>
    </el-table-column>

    <el-table-column width="120">
      <template slot-scope="scope">
        <div v-if="scope.$index < tableData.length - 1">
          <el-button class="handle-btn egl-btn-white-gray-border" v-if="tableData.length > 2" @click="removeRow(scope.$index)">
            <i class="el-icon-minus"></i>
          </el-button>
          <el-button class="handle-btn egl-btn-white-gray-border" v-if="scope.$index == tableData.length - 2" @click="addRow">
            <i class="el-icon-plus"></i>
          </el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { createOffsetOtherTableTr } from "@/assets/js/accountPayable.js";
import { getOtherGoodList } from "@/helpers/service/api/accountPayable.js";
import { mapState } from "vuex";

export default {
  name: "AccountPayablePaymentOtherOffsetTable3",
  data() {
    return {
      tableData: [],
      otherGoodsList: [],
      otherGoodsOption: [],
    };
  },
  computed: {
    ...mapState("api", { cinemaList: state => state.cinemaList }),
    ...mapState("accountPayable", { offsetHistory: state => state.offsetHistory }),
  },
  methods: {
    spanMethod({rowIndex, columnIndex}) {
      let obj = {
        rowspan: 1,
        colspan: 1,
      };
      let dataLength = this.tableData.length;

      if (rowIndex == dataLength - 1) {
        if (columnIndex == 2) {
          obj.colspan = 3;
        } else if (columnIndex >= 3) {
          obj.colspan = 1;
        } else {
          obj.colspan = 0;
        }
      }

      return obj
    },
    setCellClassName({rowIndex, columnIndex}) {
      if (columnIndex == 3 || columnIndex == 4 || columnIndex == 5 || columnIndex == 6 || rowIndex == this.tableData.length - 1) {
        return "ta-r"
      }
    },
    setProp() {
      let lastTr_payAmount = 0;

      let tableData = [ ...this.tableData ];
      let targetTable = [];

      for (let i = 0; i < tableData.length - 1; i++) {
        if (tableData[i].otherGoodsId) {
          lastTr_payAmount += tableData[i].payAmount;
          targetTable.push({ ...tableData[i] });
        }
      }

      this.tableData[this.tableData.length - 1].payAmount = lastTr_payAmount;
      this.$emit("setOffset", "other", targetTable, lastTr_payAmount);
    },
    setMathematical(index) {
      if (this.tableData[index].otherGoodsId) {
        this.tableData[index].payAmount = -this.tableData[index].payAmount;
        this.setProp();
      }
    },
    selectCinemaId(index) {
      const cinemaId = this.tableData[index].cinemaId;
      let cinemaName = "";
      let isGetOtherGoods = false;

      for (let i = 0; i < this.cinemaList.length; i++) {
        if (cinemaId == this.cinemaList[i].id) {
          cinemaName = this.cinemaList[i].name;
          break;
        }
      }

      for (let i = 0; i < this.otherGoodsList.length; i++) {
        if (cinemaId == this.otherGoodsList[i].cinemaId) {
          isGetOtherGoods = true;
          this.otherGoodsOption[index] = [ ...this.otherGoodsList[i].list ];
          break;
        }
      }

      this.tableData[index].cinemaName = cinemaName;
      this.tableData[index].otherGoodsId = "";
      this.tableData[index].otherName = "";
      this.tableData[index].price = "-";
      this.tableData[index].inventory = "-";
      this.tableData[index].unit = "-";
      this.tableData[index].payAmount = 0;
      this.tableData[index].comment = "";
      this.setProp();

      if (!isGetOtherGoods) {
        this.getOtherGoodsList_fn(cinemaId, index);
      }
    },
    getOtherGoodsList_fn(id, index) {
      getOtherGoodList(id).then(res => {
        if (res.success) {
          let otherGoodsOption = [ ...this.otherGoodsOption ];
          let otherGoodsList = [ ...this.otherGoodsList ];

          otherGoodsList.push({
            cinemaId: id,
            list: res.data.data,
          });
          otherGoodsOption[index] = res.data.data;

          this.otherGoodsList = otherGoodsList;
          this.otherGoodsOption = otherGoodsOption;
        }
      }).catch(err => {});
    },
    selectOtherGoodsId(index) {
      const id = this.tableData[index].otherGoodsId;
      const plus = this.tableData[index].plus;
      let otherGoodsObj = {};
      let payAmount = 0;

      for (let i = 0; i < this.otherGoodsOption[index].length; i++) {
        if (id == this.otherGoodsOption[index][i].id) {
          otherGoodsObj = { ...this.otherGoodsOption[index][i] };
          break;
        }
      }

      payAmount = otherGoodsObj.price * otherGoodsObj.inventory;
      payAmount = plus ? payAmount : -payAmount;

      this.tableData[index].otherName = otherGoodsObj.name;
      this.tableData[index].price = otherGoodsObj.price;
      this.tableData[index].inventory = otherGoodsObj.inventory;
      this.tableData[index].unit = otherGoodsObj.unit;
      this.tableData[index].payAmount = payAmount;
      this.tableData[index].comment = otherGoodsObj.comment;
      this.setProp();
    },
    setRowTotalPrice(index, keyName, isInput = true) {
      let price = this.tableData[index].price;
      let inventory = this.tableData[index].inventory;
      let payAmount = 0;
      let plus = this.tableData[index].plus;
      let num = this.tableData[index][keyName];

      price = parseInt(price.toString().replace(/[^\d-]/g, "")) || 0;
      inventory = parseInt(inventory.toString().replace(/[^\d-]/g, "")) || 0;
      payAmount = price * inventory;
      payAmount = plus ? payAmount : -payAmount;

      num = num.toString().replace(/[^\d-]/g, "");
      if (!isInput) {
        num = parseInt(num) || 0;
      }

      this.tableData[index].price = price;
      this.tableData[index].inventory = inventory;
      this.tableData[index].payAmount = payAmount;
      this.tableData[index][keyName] = num;
      this.setProp();
    },
    addRow() {
      let rowItem = createOffsetOtherTableTr();
      let tableData = [ ...this.tableData ];

      tableData.splice(tableData.length - 1, 0, rowItem);
      this.tableData = tableData;
      this.otherGoodsOption = [ ...this.otherGoodsOption, [] ];
    },
    removeRow(index) {
      let tableData = [ ...this.tableData ];
      let otherGoodsOption = [ ...this.otherGoodsOption ];

      tableData.splice(index, 1);
      otherGoodsOption.splice(index, 1);

      this.tableData = tableData;
      this.otherGoodsOption = otherGoodsOption;
      this.setProp();
    },
  },
  mounted() {
    let lastTr = {
      otherName: this.$locale("global.total"),
      payAmount: 0,
    };
    let trs = [];

    if (this.offsetHistory.other && this.offsetHistory.other.length > 0) {
      this.offsetHistory.other.map((item, index) => {
        trs.push({ ...item });

        lastTr.payAmount += item.payAmount;

        this.getOtherGoodsList_fn(item.cinemaId, index);
      });

      this.$emit("setOffset", "other", trs, lastTr.payAmount);
    } else {
      trs.push(createOffsetOtherTableTr());
    }

    this.tableData = [ ...trs, lastTr ];
    this.otherGoodsOption = [ [] ];
  },
};
</script>
